import Fnc from '../library/Functions';
import React from 'react';
import {
	useLocation
} from "react-router-dom";


function PageTraking(props) {

	const useLocationChange = (action) => {
		const location = useLocation()
		React.useEffect(() => { action(location) }, [location])
	}

	useLocationChange((location) => {
		Fnc.log("Cambio URL navigazione APP:", location, Fnc.LogLvl.DEBUG);

		if (window.gtag) {
			//disabilita invio automatico per le pagine gestite da questa funzione React. A volte sbaglia il path.
			window.gtag('config', Fnc.currEnv().gaMeasurementId, {
				send_page_view: false
			});
			//invio manuale della pagina vista corretta
			let stepByUrl = Fnc.getStepByUrl();
			let pageTitle = "";
			if(stepByUrl && stepByUrl != null) {
				pageTitle = stepByUrl.desc;
			} else {
				pageTitle = props.pageTitle ? props.pageTitle : document.title;
			}
			if (!stepByUrl || stepByUrl.gaCheckoutStep <= 0) {
				// non traccio gli step checkout perché c'è già apposito evento + pagina vista FAKE con codici prodotto. (vedi file Basket.js e Functions.js)
				Fnc.gaPageview(pageTitle, document.location.href, document.location.pathname);
			}
			Fnc.wtPageview(); //pagina vista su WT
		}

	})


	return (
		<>
		</>
	);
}

export default PageTraking;